import React__default from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { useGetShippingMethods } from '@grandvisionhq/shipping';
import { useDispatch, useStore } from '@grandvisionhq/state';
import { selectShippingMethod } from '../../../actions.js';
import { getSelectedShippingMethod } from '../../../selectors.js';
import { shippingMethodsFailed, shippingMethodsSuccess } from '../state/actions.js';

const useShippingMethodsList = ()=>{
    const dispatch = useDispatch();
    const { cart  } = Context.useCart();
    const store = useStore();
    /**
   *  Error handler for shippingMethodForCart query operation
   */ const onShippingMethodsLoadError = React__default.useCallback((errorResponse)=>{
        dispatch(shippingMethodsFailed({
            message: 'Unable to load shipping methods'
        }));
        console.error(`query:[shippingMethodForCart]: unable to load shipping methods`, errorResponse);
    }, [
        dispatch
    ]);
    /**
   *  Success handler for shippingMethodForCart query operation
   */ const onShippingMethodsLoadCompleted = React__default.useCallback((shippingMethodList)=>{
        const selectedShippingMethod = getSelectedShippingMethod(store.getState());
        const isSelectedShippingMethodValid = shippingMethodList.find((method)=>{
            return (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method) == method.key;
        });
        if ((selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method) && !isSelectedShippingMethodValid) {
            dispatch(selectShippingMethod({
                shippingMethod: {
                    method: undefined,
                    isValid: false,
                    isTouched: true
                }
            }));
        } else if (cart && (cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key) !== (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method)) {
            if (cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key) {
                dispatch(selectShippingMethod({
                    shippingMethod: {
                        method: cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key,
                        isValid: true,
                        isTouched: false
                    }
                }));
            } else {
                // Cart has no shipping method information, try to use the actual default value
                // This happens when a feature toggle in cart-service (ADD_SHIPPING_METHOD_TO_CART) is disabled
                const defaultShippingMethod = shippingMethodList.find((method)=>method.isDefault
                );
                if (defaultShippingMethod) {
                    dispatch(selectShippingMethod({
                        shippingMethod: {
                            method: defaultShippingMethod.key,
                            isValid: true,
                            isTouched: false
                        }
                    }));
                }
            }
        }
        dispatch(shippingMethodsSuccess({
            result: shippingMethodList
        }));
    }, [
        cart,
        dispatch,
        store
    ]);
    const [loadShippingMethods, { called , data: shippingMethodList1 , loading , error  }] = useGetShippingMethods({
        onError: onShippingMethodsLoadError,
        onCompleted: onShippingMethodsLoadCompleted
    });
    /**
   *  Load shipping methods cart id updated
   */ React__default.useEffect(()=>{
        if ((cart === null || cart === void 0 ? void 0 : cart.id) && !called) {
            loadShippingMethods(cart === null || cart === void 0 ? void 0 : cart.id, cart === null || cart === void 0 ? void 0 : cart.prices.totalPrice);
        }
    }, [
        loadShippingMethods,
        called,
        cart
    ]);
    const reloadShippingMethods = React__default.useCallback(()=>{
        if ((cart === null || cart === void 0 ? void 0 : cart.id) && !called) {
            loadShippingMethods(cart === null || cart === void 0 ? void 0 : cart.id, cart === null || cart === void 0 ? void 0 : cart.prices.totalPrice);
        }
    }, [
        called,
        cart === null || cart === void 0 ? void 0 : cart.id,
        cart === null || cart === void 0 ? void 0 : cart.prices.totalPrice,
        loadShippingMethods
    ]);
    return {
        shippingMethodList: shippingMethodList1,
        reloadShippingMethods,
        isLoading: loading,
        error
    };
};

export { useShippingMethodsList };
//# sourceMappingURL=use-shipping-methods-list.js.map
